/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { CurrentUserService } from '@src/app/modules/user/current-user.service';
import { MessageService } from '@src/app/shared/message.service';
import { TenantService } from '@src/app/shared/tenant.service';
import { ErrorLogEntry, ErrorLogsDialogComponent } from './error-logs-dialog.component';

@Component({
    selector: 'app-error-logs',
    imports: [MatButtonModule],
    template: `
        @if (allowed) {
            <button mat-raised-button color="accent" (click)="showErrors()">
                Error Logs
            </button>
        }
    `
})
export class ErrorLogsComponent {
    private http = inject(HttpClient);
    private dialog = inject(MatDialog);
    private messageService = inject(MessageService);
    private currentUserSvc = inject(CurrentUserService);

    protected get allowed(): boolean {
        return this.currentUserSvc.hasUber();
    }

    showErrors() {
        this.http.get<ErrorLogEntry[]>(TenantService.bareAjaxPath + 'uber/error-logs').subscribe({
            next: (errors) => {
                this.dialog.open(ErrorLogsDialogComponent, {
                    data: { errors },
                    width: '95vw',
                    maxWidth: '1400px',
                    height: '85vh',
                });
            },
            error: (err) => this.messageService.showErrorMessage(err.error?.message ?? 'Could not load error logs'),
        });
    }
}
